import React from 'react';
import { Hero } from './components/Hero';
import { SalesLetter } from './components/SalesLetter';
import { TomosSection } from './components/TomosSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { CostSection } from './components/CostSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink-950 font-sans" data-id="element-0" data-mp="28ufmg62gz4gf">
      <Hero data-id="element-1" data-mp="28suumo7jhzm9" />
      <main data-id="element-2" data-mp="28sl511qepuh3">
        <SalesLetter data-id="element-3" data-mp="28s2xva27hvue" />
        <TomosSection data-id="element-4" data-mp="23vkv2fqfs7kp" />
        <BenefitsSection data-id="element-5" data-mp="23w4c7u89irxo" />
        <BonosSection data-id="element-6" data-mp="23utadzydnu97" />
        <PricingSection data-id="element-7" data-mp="23ti864kkyuk7" />
        <CostSection data-id="element-8" data-mp="3ik7jmqgv0tve" />
        <TestimonialsSection data-id="element-9" data-mp="3iiweonbohg2p" />
        <GuaranteeSection data-id="element-10" data-mp="3ijpcuzwkmx98" />
        <FaqSection data-id="element-11" data-mp="3mlj8gtrwtb2j" />
        <FinalCta data-id="element-12" data-mp="3ml1234bj9ggw" />
      </main>
      <Footer data-id="element-13" data-mp="3mjzsz5e2v41t" />
    </div>;
}